import { Box } from '@mui/material'
import { useEffect, useLayoutEffect, useMemo, useState } from 'react'
import { createPortal } from 'react-dom'
import { useAppSelector } from '../../store/hooks'

import { getDatesArray } from 'components/shared/processes'
import moment from 'moment'
import { IHistoryTableRequest } from 'models/feedplan'
import PlanApiService from 'services/planApiService'
import BreadCrumbsGroup from 'ui/breadCrumbs/BreadCrumbsGroup'

import HistoryTable from './HistoryTable'
import DateRangePicker from 'ui/DatePickerInput/DateRangePicker'

const HistoryPage = () => {
	const weekDays = getDatesArray(6)
	const [dateRange, setDateRange] = useState({
		startDate: weekDays.startDate,
		endDate: weekDays.endDate,
	})
	const dateForReq = moment(dateRange.endDate).format('YYYY-MM-DD')
	const [historyData, setHistoryData] = useState<IHistoryTableRequest[]>([])
	const [selectedGroups, setSelectedGroups] = useState<string[]>([])
	const [fetchindData, setFetchindData] = useState(true)
	const [headerSlot, setHeaderSlot] = useState<HTMLElement | null>(null)
	const handleActiveFilter = (id: string | number) => {
		if (id === 'all') {
			setSelectedGroups([])
			return
		}
		const key = String(id)
		setSelectedGroups(prev =>
			prev.includes(key) ? prev.filter(item => item !== key) : [...prev, key],
		)
	}
	const handleRemoveFilter = (id: string | number) => {
		const key = String(id)
		setSelectedGroups(prev => prev.filter(item => item !== key))
	}
	useEffect(() => {
		setFetchindData(true)
		PlanApiService.getHistoryChangedForAllGroups(dateForReq)
			.then(response => {
				setHistoryData(response)
			})
			.catch(() => setHistoryData([]))
			.finally(() => setFetchindData(false))
	}, [dateForReq])

	useLayoutEffect(() => {
		setHeaderSlot(document.getElementById('feed-history-header-actions'))
	}, [])

	const { groupList } = useAppSelector(store => store.groupsReducer)

	const historyGroups = (groupList ?? []).map(group => ({
		id: group.groupkey,
		title: group.title,
		selected: selectedGroups.includes(group.groupkey),
	}))

	const filteredHistory = useMemo(() => {
		if (selectedGroups.length === 0) return historyData
		return historyData.filter(row =>
			row.groups.some(
				group =>
					selectedGroups.includes(group.group_key) ||
					selectedGroups.includes(group.group_title),
			),
		)
	}, [historyData, selectedGroups])

	const onChangeCallback = value => {
		setDateRange({
			startDate: value[0],
			endDate: value[1],
		})
	}

	const datePicker = (
		<DateRangePicker
			startDate={dateRange.startDate}
			endDate={dateRange.endDate}
			onChangeUpdateDate={onChangeCallback}
		/>
	)

	return (
		<Box
			sx={{ pl: '24px', pr: '24px', display: 'flex', flexDirection: 'column' }}
		>
			{headerSlot && createPortal(datePicker, headerSlot)}
			<BreadCrumbsGroup
				handleActiveFilter={handleActiveFilter}
				handleRemoveFilter={handleRemoveFilter}
				array={historyGroups}
			/>
			<HistoryTable
				historyData={filteredHistory}
				fetchindData={fetchindData}
				groupList={groupList}
			/>
		</Box>
	)
}

export default HistoryPage
